import { localeModules } from "#i18n/locale-modules";
const messages = {};
for (const [path, module] of Object.entries(localeModules)) {
	const match = path.match(/\.\/locales\/([^/]+)\/([^/]+)\.ts$/);
	if (!match) continue;
	const locale = match[1];
	const namespace = match[2];
	if (!locale || !namespace) continue;
	messages[locale] ??= {};
	messages[locale][namespace] = module;
}
export default () => ({
	legacy: false,
	messages
});
